export function mapById (data = []) {
	return mapByFn(data, (entry) => entry.id);
}

export function mapByFn (data = [], fn) {
	return data.reduce((map, entry) => {
		map[fn(entry)] = entry;
		return map;
	}, {});
}